<template>
  <div class="animated fadeIn list-of-ar">
    <b-card>
      <div slot="header">
        AR Invoice - Collection View
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="payment()">Payment History</b-button>
          <b-button variant="primary mr-1" @click="collectionStatus()">Update Collection Status</b-button>
          <b-dropdown text="Print" variant="primary mr-1">
            <b-dropdown-item @click="print">Form/Billing</b-dropdown-item>
            <b-dropdown-item @click="printkwitansi">Kwitansi</b-dropdown-item>
            <b-dropdown-item @click="printlist">List AR Inv.</b-dropdown-item>
            <b-dropdown-item @click="printlistbycustomer">List AR Inv. per Customer</b-dropdown-item>
          </b-dropdown>

          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>Export</b-button>
          <b-button variant="primary mr-1" @click="togleFilter()"><i class="fa fa-filter"></i> Filter</b-button>
          <b-button variant="primary mr-1" @click="close()"> <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend><label>Invoice Date</label></b-input-group-prepend>
            <b-form-input v-model="tblData.tgl1" type="date" style="width: 18% !important"></b-form-input>
            <b-input-group-prepend><span class="input-group-text">-</span></b-input-group-prepend>
            <b-form-input v-model="tblData.tgl2" type="date" style="width: 18% !important"></b-form-input>
            <b-input-group-prepend><span class="pt-2">&nbsp;Source </span></b-input-group-prepend>
            <b-form-select v-model="tblData.invmanual" :plain="true" :options="invSources"></b-form-select>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Invoice Number</label></b-input-group-prepend>
            <b-form-input v-model="tblData.nomor" placeholder="Invoice No. (% for wildcard)" style="width: 33% !important"></b-form-input>
            <b-input-group-prepend><span class="pt-2">&nbsp;Sales </span></b-input-group-prepend>
            <b-form-select v-model="tblData.deffered" :plain="true" :options="invDeffers" v-b-tooltip.hover title="Actual/UnEarned" class="ml-1"></b-form-select>
            <b-input-group-prepend><span class="ml-2 pt-2">Posted &nbsp;</span></b-input-group-prepend>
            <b-form-select v-model="tblData.posting" :plain="true" :options="dataList.postingStatus" style="width: 9% !important"></b-form-select>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend><label>Outstanding Status</label></b-input-group-prepend>
            <b-form-select v-model="tblData.outstand" :plain="true" :options="dataList.YesNoAll"></b-form-select>
            <b-input-group-prepend><span class="ml-2 pt-2">Ost.group &nbsp;</span></b-input-group-prepend>
            <b-form-select
              v-model="tblData.ostStatuskey"
              :plain="true"
              :options="dataList.ostandStatus"
              class="ml-1"
              style="width: 14% !important"
              v-b-tooltip.hover
              title="Outstanding Group"
            ></b-form-select>
            <b-input-group-prepend><span class="ml-2 pt-2">Canceled</span></b-input-group-prepend>
            <b-form-select v-model="tblData.canceled" :plain="true" :options="dataList.YesNoAll" class="ml-1" v-b-tooltip.hover title="Cancelation&Reissued"></b-form-select>
          </b-input-group>
        </b-col>
        <b-col lg="6">
          <b-row no-gutters>
            <b-col lg="5">
              <b-input-group>
                <b-input-group-prepend><label>Customer</label></b-input-group-prepend>
                <b-form-input v-model="tblData.customer"></b-form-input>
                <b-input-group-append>
                  <b-btn text="Button" @click="lkuCustomerShow = true">
                    <i class="fa fa-search"></i>
                  </b-btn>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col lg="7">
              <b-input-group>
                <b-input-group-prepend><span class="pt-2">&nbsp; Desc &nbsp;</span></b-input-group-prepend>
                <b-form-input v-model="tblData.uraian" placeholder="Invoice Description"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-row no-gutters>
            <b-col lg="5">
              <b-input-group>
                <b-input-group-prepend><label>Order Number</label></b-input-group-prepend>
                <b-form-input v-model="tblData.po" placeholder="Purch. Order#"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="7">
              <b-input-group>
                <b-input-group-prepend><span class="pt-2">&nbsp; Dimension &nbsp;</span></b-input-group-prepend>
                <b-form-select v-model="tblData.DimCol" :plain="true" :options="dimension"></b-form-select>
                <b-form-input v-model="tblData.DimVal" placeholder="Dimension Value" class="ml-1" style="width: 35% !important"></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <b-input-group>
            <b-input-group-prepend><label>Bentuk Bayar</label></b-input-group-prepend>
            <b-form-select v-model="tblData.pack_name" :plain="true" :options="paymentForms"></b-form-select>
            <b-input-group-prepend><span class="ml-2 pt-2">AR Group &nbsp;</span></b-input-group-prepend>
            <b-form-select v-model="tblData.postgroup" :plain="true" :options="postGroups"></b-form-select>
            <b-input-group-append>
              <b-button variant="success" size="sm" @click="search()" class="ml-3"> <i class="fa fa-refresh"></i> Apply Filter</b-button>
            </b-input-group-append>
            <b-input-group-append>
              <b-button variant="secondary" size="sm" class="ml-2" @click="clearFilter()">Clear Filter</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive
        striped
        hover
        style="font-size: smaller"
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        @row-clicked="rowClicked"
      >
        <template v-slot:cell(action)="data">
          <b-dropdown dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret size="sm" style="margin: -10px">
            <template v-slot:button-content>
              <i class="fa fa-play text-primary"></i>
            </template>
            <b-dropdown-item @click="rowPayment(data.item)" href="#" style="padding: 0 !important">Payment History</b-dropdown-item>
            <b-dropdown-item @click="rowCollstatus(data.item)" href="#" style="padding: 0 !important">Collection Status</b-dropdown-item>
            <b-dropdown-item @click="rowPrint(data.item)" href="#" style="padding: 0 !important">Print Invoice/Bill</b-dropdown-item>
            <b-dropdown-item @click="rowPrintkwitansi(data.item)" href="#" style="padding: 0 !important">Print Kwitansi</b-dropdown-item>
          </b-dropdown>
        </template>
        <!-- <template v-slot:cell(actionright)="data">
        <b-dropdown  dropright variant="outline-secondary" toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-primary"></i>
          </template>
          <b-dropdown-item @click="rowPayment(data.item)" href="#"  style="padding:0 !important;">Payment</b-dropdown-item>
          <b-dropdown-item @click="rowCollstatus(data.item)" href="#"  style="padding:0 !important;">Collection Status</b-dropdown-item>
          <b-dropdown-item @click="rowPrint(data.item)" href="#" style="padding:0 !important;">Print JV</b-dropdown-item>
        </b-dropdown>
      </template>   -->

        <template v-slot:cell(invdate)="data">
          {{ data.item.invdate | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(invoiceno)="data">
          <div v-if="data.item.posting == 0" style="background-color: yellow">
            {{ data.item.invoiceno }}
          </div>
          <div v-else>
            {{ data.item.invoiceno }}
          </div>
        </template>
        <template v-slot:cell(ordernumber)="data">
          <span v-if="data.item.kontrakprd">{{ data.item.kontrakprd }}</span>
          <span v-else>{{ data.item.ordernumber }}</span>
        </template>

        <template v-slot:cell(totalinv)="data">
          {{ data.item.totalinv | numFormat("0,0.00") }}
        </template>
        <template v-slot:cell(outstd_semu)="data">
          {{ data.item.outstd_semu | numFormat("0,0.00") }}
        </template>
        <template v-slot:cell(byr_semu)="data">
          {{ data.item.byr_semu | numFormat("0,0.00") }}
        </template>
        <template v-slot:cell(colleNote)="data">
          <span v-if="data.item.colleNote"
            ><b-link @click.stop="showActionHistory(data.item)">{{ data.item.colleNote }}</b-link></span
          >
          <span v-else>{{ data.item.colleNote }}</span>
        </template>
      </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-1">
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }} to <span v-if="tblData.page * tblData.limit > tblData.total">{{ tblData.total }}</span>
            <span v-else>{{ tblData.page * tblData.limit }}</span> of {{ tblData.total }} entries
          </div>
        </b-col>
        <b-col cols="5">
          <b-input-group>
            <b-input-group-prepend><span class="pt-1 pr-2">Limit per page</span></b-input-group-prepend>
            <b-form-input v-model="limit" type="number" class="mr-2" v-b-tooltip.hover :title="`${limit} records`" style="max-width:80px; !important;"></b-form-input>
            <b-pagination v-if="pagination" :total-rows="tblData.total" :per-page="tblData.limit" v-model="tblData.page"></b-pagination>
          </b-input-group>
        </b-col>
        <b-col cols="3">
          <div class="text-right pt-1">
            <span style="background-color: yellow">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <span class="mr-2">Record Not Posted</span>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <b-modal v-model="showStatusForm" size="lg" title="Update Collection Status" header-bg-variant="primary" :centered="true" @ok="handleOk" ok-title="Save">
      <b-form @submit.stop.prevent="updateStatus">
        <b-input-group>
          <b-input-group-prepend><label>Invoice Number</label></b-input-group-prepend>
          <b-form-input v-model="model.invoiceno" readonly></b-form-input>
          <b-form-radio-group class="mt-2" v-model="model.proforma" disabled>
            <b-form-radio value="0">Invoice Actual</b-form-radio>
            <b-form-radio value="1">Unearned Income</b-form-radio>
          </b-form-radio-group>
          <b-input-group-prepend><span class="p-2">Invoice Date</span></b-input-group-prepend>
          <b-form-input v-model="model.invdate" type="date" disabled></b-form-input>
        </b-input-group>
        <b-input-group>
          <b-input-group-prepend><label>Customer</label></b-input-group-prepend>
          <b-form-input readonly v-model="model.custinfo" style="width: 30% !important"></b-form-input>
          <b-input-group-prepend><span class="p-2">Sales Order No.</span></b-input-group-prepend>
          <b-form-input readonly v-model="model.ordernumber"></b-form-input>
        </b-input-group>
        <b-input-group>
          <b-input-group-prepend><label>Description</label></b-input-group-prepend>
          <b-form-input v-model="model.uraian1" readonly></b-form-input>
          <b-form-input v-model="model.uraian2" readonly class="ml-1"></b-form-input>
        </b-input-group>
        <b-form-row>
          <b-col cols="6">
            <b-input-group>
              <b-input-group-prepend><label>Invoice Amount</label></b-input-group-prepend>
              <b-input-group-prepend
                ><span class="input-group-text" style="width: 60px">{{ model.matauang }}</span></b-input-group-prepend
              >
              <my-number class="form-control text-right" separator="," v-model="model.totalinv" :precision="2" readonly></my-number>
            </b-input-group>
          </b-col>
          <b-col cols="6">
            <b-input-group>
              <b-input-group-prepend><label>Reff other Invoice#</label></b-input-group-prepend>
              <b-form-input v-model="model.invoicereff" readonly=""></b-form-input>
            </b-input-group>
          </b-col>
        </b-form-row>
        <!-- <hr> -->
        <b-row>
          <b-col lg="6">
            <b-input-group>
              <b-input-group-prepend><label>Outstanding Status </label></b-input-group-prepend>
              <b-form-select v-model="frmdata.ostStatuskey" :plain="true" :options="dataList.ostandStatus" :state="!$v.frmdata.ostStatuskey.$error"></b-form-select>
            </b-input-group>
          </b-col>
          <b-col lg="6">
            <b-input-group>
              <b-input-group-prepend><span class="p-2">Collector</span></b-input-group-prepend>
              <b-form-select v-model="frmdata.collector_id" :plain="true" :options="collectors"></b-form-select>
              <!-- <b-form-input  v-model="frmdata.collector" ></b-form-input> -->
            </b-input-group>
          </b-col>
        </b-row>
        <b-input-group>
          <b-input-group-prepend><label>Collection Note</label></b-input-group-prepend>
          <b-form-input v-model="frmdata.colleNote" :state="!$v.frmdata.colleNote.$error"></b-form-input>
        </b-input-group>
      </b-form>
    </b-modal>
    <b-modal v-model="actionHistoryShow" header-bg-variant="primary" title="Collection Action History" size="lg" :centered="true" ok-only>
      <b-input-group>
        <b-input-group-prepend><label>Invoice Number</label></b-input-group-prepend>
        <b-form-input v-model="model.invoiceno" readonly></b-form-input>
        <b-form-radio-group class="mt-2" v-model="model.proforma" disabled>
          <b-form-radio value="0">Invoice Actual</b-form-radio>
          <b-form-radio value="1">Unearned Income</b-form-radio>
        </b-form-radio-group>
        <b-input-group-prepend><span class="p-2">Invoice Date</span></b-input-group-prepend>
        <b-form-input :value="model.invdate | moment('DD MMM YYYY')" disabled></b-form-input>
      </b-input-group>
      <b-input-group>
        <b-input-group-prepend><label>Customer</label></b-input-group-prepend>
        <b-form-input readonly v-model="model.custinfo" style="width: 30% !important"></b-form-input>
        <b-input-group-prepend><span class="p-2">Sales Order No.</span></b-input-group-prepend>
        <b-form-input readonly v-model="model.ordernumber"></b-form-input>
      </b-input-group>
      <b-input-group>
        <b-input-group-prepend><label>Description</label></b-input-group-prepend>
        <b-form-input v-model="model.uraian1" readonly></b-form-input>
        <b-form-input v-model="model.uraian2" readonly class="ml-1"></b-form-input>
      </b-input-group>
      <b-form-row>
        <b-col cols="6">
          <b-input-group>
            <b-input-group-prepend><label>Invoice Amount</label></b-input-group-prepend>
            <b-input-group-prepend
              ><span class="input-group-text" style="width: 60px">{{ model.matauang }}</span></b-input-group-prepend
            >
            <my-number class="form-control text-right" separator="," v-model="model.totalinv" :precision="2" readonly></my-number>
          </b-input-group>
        </b-col>
        <b-col cols="6">
          <b-input-group>
            <b-input-group-prepend><label>Reff other Invoice#</label></b-input-group-prepend>
            <b-form-input v-model="model.invoicereff" readonly=""></b-form-input>
          </b-input-group>
        </b-col>
      </b-form-row>
      <div class="report-wraper">
        <table width="100%">
          <thead>
            <tr>
              <th width="120px">Action Date</th>
              <th>Collectio Note</th>
              <th width="100px">Input By</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in actionHistory" :key="row.ARfollowID">
              <td>{{ row.modified | moment("dddd , DD-MMM-YYYY hh:mm:ss") }}</td>
              <td>{{ row.pesan }}</td>
              <td>{{ row.createby }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </b-modal>

    <b-modal v-model="showPaymentForm" scrollable size="xl" title="AR Payment/Settlement History" hide-footer>
      <b-form-row>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend><label>Invoice Number</label></b-input-group-prepend>
            <b-form-input v-model="paymdata.invoiceno" readonly></b-form-input>
          </b-input-group>
        </b-col>
        <b-col lg="6">
          <b-input-group>
            <b-input-group-prepend><label>Invoice Date</label></b-input-group-prepend>
            <b-form-input :value="paymdata.invdate | moment('DD MMM YYYY')" disabled></b-form-input>
          </b-input-group>
        </b-col>
      </b-form-row>
      <b-input-group>
        <b-input-group-prepend><label>Customer</label></b-input-group-prepend>
        <b-form-input readonly v-model="paymdata.custinfo"></b-form-input>
      </b-input-group>
      <b-input-group>
        <b-input-group-prepend><label>Description</label></b-input-group-prepend>
        <b-form-input v-model="paymdata.uraian1" readonly></b-form-input>
        <b-form-input v-model="paymdata.uraian2" readonly class="ml-1"></b-form-input>
      </b-input-group>
      <b-input-group>
        <b-input-group-prepend><label>Purchase Order#</label></b-input-group-prepend>
        <b-form-input readonly v-model="paymdata.ordernumber"></b-form-input>
        <b-form-radio-group class="mt-2" v-model="paymdata.proforma" name="radioProforma" disabled>
          <b-form-radio value="0">Actual Invoice</b-form-radio>
          <b-form-radio value="1">Proforma (PBB) Invoice</b-form-radio>
        </b-form-radio-group>
      </b-input-group>
      <b-form-row>
        <b-col cols="6">
          <b-input-group>
            <b-input-group-prepend><label>Invoice Amount</label></b-input-group-prepend>
            <b-input-group-prepend
              ><span class="input-group-text" style="width: 60px">{{ paymdata.matauang }}</span></b-input-group-prepend
            >
            <my-number class="form-control text-right" separator="," v-model="paymdata.totalinv" :precision="2" readonly></my-number>
          </b-input-group>
        </b-col>
        <b-col cols="6">
          <b-input-group>
            <b-input-group-prepend><label>Related to other Invoice #</label></b-input-group-prepend>
            <b-form-input v-model="model.invoicereff" readonly=""></b-form-input>
          </b-input-group>
        </b-col>
      </b-form-row>
      <b-card no-body class="mb-1">
        <div class="report-wraper">
          <table style="width: 100%">
            <thead>
              <tr>
                <th width="80px">Settlement Date</th>
                <th width="110px">Doc. Number</th>
                <th width="110px">Settlement Method</th>
                <th>Description</th>
                <th width="90px">Input By</th>
                <th width="140px" style="text-align: right">Credit</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in paymdata.paymLines" :key="row.tablekey">
                <td :class="row.kelas">{{ row.tanggal | moment("DD MMM YYYY") }}</td>
                <td :class="row.kelas">{{ row.nomor }}</td>
                <td :class="row.kelas">{{ row.paymethod }}</td>
                <td :class="row.kelas">{{ row.uraian }}</td>
                <td :class="row.kelas">{{ row.createby }}</td>
                <td :class="row.kelas" style="text-align: right">{{ row.nilaibayar | numFormat("0,0.00") }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-card>
      <b-row class="mt-1">
        <b-col lg="6">
          <div class="text-right">
            <b-input-group>
              <b-input-group-prepend><label style="text-align: left; width: 158px; padding-left: 16px">Total Settlement</label></b-input-group-prepend>
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 60px">{{ paymdata.matauang }}</span>
              </b-input-group-prepend>
              <my-number class="form-control text-right" v-model="paymdata.totalsettle" :precision="2" disabled></my-number>
            </b-input-group>
          </div>
        </b-col>
        <b-col lg="6">
          <div class="text-right">
            <b-input-group>
              <b-input-group-prepend><label style="text-align: left; width: 158px; padding-left: 16px">Outstanding</label></b-input-group-prepend>
              <b-input-group-prepend>
                <span class="input-group-text" style="width: 60px">{{ paymdata.matauang }}</span>
              </b-input-group-prepend>
              <my-number class="form-control text-right" v-model="paymdata.outstand" :precision="2" disabled></my-number>
            </b-input-group>
          </div>
        </b-col>
      </b-row>
    </b-modal>
    <b-modal v-model="lkuCustomerShow" size="lg" :hide-footer="true" title="List of Customer" :centered="true">
      <lku-customer @click="onSelectLkuCustomer"></lku-customer>
    </b-modal>
  </div>
</template>

<style lang="scss">
.list-of-ar {
  table {
    td:nth-child(1) {
      width: auto;
    }
    td:nth-child(2) {
      width: auto;
    }
    td {
      .dropdown-item {
        padding: 0.1rem 1.5rem !important;
        font-size: smaller !important;
      }
    }
  }
  .ColsDefine {
    .input-group {
      .input-group-prepend {
        label {
          width: 135px !important;
        }
      }
    }
  }
}
</style>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import myNumber from "../../components/my-number";
import moment from "moment";
import lkuCustomer from "../lookup/lkuCustomer";
import crud from "../../apis/crud";
import arinv from "../../apis/arinv";
import dropdown from "../../data/dropdown";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import toastr from "mini-toastr";
toastr.init();

export default {
  components: { myNumber, Loading, lkuCustomer },
  mixins: [validationMixin],
  validations: {
    frmdata: {
      ostStatuskey: { required },
      colleNote: { required },
    },
  },

  data() {
    return {
      lkuCustomerShow: false,
      actionHistoryShow: false,
      actionHistory: [],
      showFilter: false,
      showStatusForm: false,
      showPaymentForm: false,
      paymdata: { paymLines: [] },
      fileXlsx: null,
      horizontal: true,
      isLoading: false,
      showReport: false,
      reportUrl: null,
      limit: 15,
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        // tgl1:this.$store.state.user.tglaktif,
        // tgl2:this.$store.state.user.akhirbln,
        tgl1: "",
        tgl2: "",
        sortBy: "invdate",
        sortDesc: true,
        DimCol: "Dim1",
        outstand: "1",
      },
      pagination: false,
      model: {},
      frmdata: { ostStatuskey: "", colleNote: "" },
      artypes: [],
      arWithSale: [],
      invSources: [
        { value: "", text: "--- ALL ---" },
        { value: "0", text: "Upload/Import" },
        { value: "1", text: "Manual Entry" },
      ],
      invDeffers: [
        { value: "", text: "--- ALL ---" },
        { value: "0", text: "Actual Invoice" },
        { value: "1", text: "Unearned Invoice" },
      ],
      postGroups: [{ value: "", text: "--- ALL ---" }],
      paymentForms: [{ value: "", text: "--- ALL ---" }],
      collectors: [],
      dataList: {
        YesNoAll: dropdown.ostandStatus,
        postingStatus: dropdown.postingStatus,
        ostandStatus: [{ value: "", text: "" }],
      },
    };
  },
  computed: {
    dimension() {
      return this.$store.state.dimension;
    },
    tblFields() {
      const fields = [
        {
          key: "action",
          label: "",
          thStyle: "width:70px",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "invoiceno",
          thStyle: "width:80px",
          label: "Invoice No.",
          sortable: true,
        },
        {
          key: "invdate",
          thStyle: "width:70px",
          label: "Inv. Date",
          sortable: true,
        },
        {
          key: "custinfo",
          label: "Customer",
          thStyle: "width:150px",
          sortable: true,
        },
        {
          key: "uraian",
          thStyle: "width:400px",
          label: "Description",
          sortable: true,
        },
        {
          key: "ordernumber",
          thStyle: "width:120px",
          label: "No. Order",
          sortable: true,
        },
        {
          key: "accexec",
          thStyle: "width:80px",
          label: "AE",
          sortable: true,
        },
        {
          key: "pack_name",
          label: "Payment",
          sortable: true,
        },
        {
          key: "matauang",
          thStyle: "width:40px",
          label: "$,¥",
          sortable: true,
        },
        {
          key: "totalinv",
          label: "Invoice Amount",
          thStyle: "width:120px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "outstd_semu",
          label: "Outstanding",
          thStyle: "width:120px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "byr_semu",
          label: "Not Efective Settlement",
          thStyle: "width:120px",
          thClass: "text-right",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "collector",
          label: "collector",
          sortable: true,
        },
        {
          key: "ostStatusname",
          thStyle: "width:100px",
          label: "Outstand Status",
          sortable: true,
        },
        {
          key: "colleNote",
          thStyle: "width:200px",
          label: "Note",
          sortable: true,
        },
        {
          key: "invoicereff",
          thStyle: "width:90px",
          label: "Related to Other Inv.#",
          sortable: true,
        },
        {
          key: "accexec",
          label: "AE",
          sortable: true,
        },
        //    {
        //   key: "actionright",
        //   label: "",
        //   thStyle: "width:70px",
        //   thClass: "text-center",
        //   tdClass: "text-center",
        // },
      ];
      // const dims = this.$store.state.dimension;
      // for (let i = 0; i < dims.length; i += 1) {
      //   fields.push(          {
      //     key: `${dims[i].value}Txt`,
      //     thStyle: "width:100px",
      //     label: dims[i].text,
      //     sortable: true
      //   },)
      // }
      return fields;
    },
    dimCol() {
      return this.tblData.DimCol;
    },
    invalidModel() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
  },
  watch: {
    dimCol: function (newval) {
      this.tblData.DimVal = "";
      this.tblData.DimValInfo = "";
      this.tblData.DimColInfo = this.dimension.find((d) => d.value === newval).text;
    },
    limit: function (newVal) {
      setTimeout(() => {
        if (this.limit == newVal) {
          this.tblData.limit = newVal;
        }
      }, 500);
    },
  },
  created: function () {
    setTimeout(async () => {
      const [a, b, f, e] = await Promise.all([
        arinv.postgroup(),
        arinv.outstandstatus(),
        arinv.paymentform(),
        crud.list({ tablename: "vwcollector", page: 1, limit: 1000, sortBy: "collector_name", sortDesc: false }),
      ]);
      this.artypes = a;
      // this.dataList.ostandStatus = b;
      this.dataList.ostandStatus = this.dataList.ostandStatus.concat(b);

      // this.artypes = await arinv.postgroup();
      this.postGroups = this.artypes.reduce(
        (newArr, item) => {
          if (item.saleCode) {
            this.arWithSale.push(item);
          }
          newArr.push(item);
          return newArr;
        },
        [{ value: "", text: "--- ALL ---" }],
      );

      this.paymentForms = f.reduce(
        (newArr, item) => {
          newArr.push(item);
          return newArr;
        },
        [{ value: "", text: "--- ALL ---" }],
      );

      this.collectors = e.reduce((newArr, item) => {
        newArr.push({ value: item.collector_id, text: item.collector_name });
        return newArr;
      }, []);
    }, 1000);
    // const tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
    // this.tblData.tgl1= this.tblData.tgl1 || this.$store.state.user.tglaktif;
    // this.tblData.tgl2= this.tblData.tgl2 || tgl2.format('YYYY-MM-DD');
  },
  methods: {
    onSelectLkuCustomer: async function (_selected) {
      this.tblData.customer = _selected.CustName.trim();
      this.tblData.custcode = _selected.CustCode;
      // this.tblData.customer_id = _selected.customer_id;
      this.lkuCustomerShow = false;
    },
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function (ctx) {
      const tblOrder = { sortBy: this.tblData.sortBy, sortDesc: this.tblData.sortDesc };
      this.pagination = false;
      const filter = this.$store.state.filter;
      let filtered = false;
      for (var key in filter.arinvlist) {
        this.tblData[key] = filter.arinvlist[key];
        filtered = true;
      }
      if (filtered === true) {
        if (!filter.arinvlist.tgl1) {
          this.tblData.tgl1 = "";
          this.tblData.tgl2 = "";
        }
        this.showFilter = filtered;
        delete filter.arinvlist;
        this.$store.commit("filter", filter);
        let autoRefresh = true;
        if (this.tblData.page == 1) {
          if (tblOrder.sortBy == this.tblData.sortBy && tblOrder.sortDesc == this.tblData.sortDesc) {
            autoRefresh = false;
          } else autoRefresh = true;
        }
        if (autoRefresh == false) {
          this.isLoading = true;
          this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
          try {
            const list = await arinv.collectorview(this.tblData);
            this.pagination = true;
            this.items = list;
            this.isLoading = false;
            return list;
          } catch (error) {
            this.isLoading = false;
            if (error.message) {
              toastr.error(error.message, "ERROR MESSAGE", 10000);
            } else {
              toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
            }
          }
        }
      } else {
        this.isLoading = true;
        this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
        try {
          const list = await arinv.collectorview(this.tblData);
          this.pagination = true;
          this.items = list;
          this.isLoading = false;
          return list;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      }
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },

    search(ctx) {
      this.tblData.page = 1;
      this.refresh();
    },
    clearFilter(ctx) {
      this.tblData.customer = "";
      this.tblData.custcode = "";
      this.tblData.po = "";
      this.tblData.uraian = "";
      this.tblData.nomor = "";
      this.tblData.posting = "";
      this.tblData.postgroup = "";
      this.tblData.tgl1 = "";
      this.tblData.tgl2 = "";
      this.tblData.DimVal = "";
      this.tblData.invmanual = "";
      this.tblData.ostStatuskey = "";
      this.tblData.outstand = "";
      this.$forceUpdate();
    },
    togleFilter() {
      this.showFilter = !this.showFilter;
    },
    saveFilter() {
      const keys = ["uraian", "DimCol", "DimVal", "tgl1", "tgl2", "outstand", "nomor", "customer", "po", "postgroup", "pack_name", "posting", "invmanual", "ostStatuskey", "custcode", "canceled"];
      let filtered = false;
      const arinvlist = {};
      for (const key in this.tblData) {
        if (keys.indexOf(key) >= 0 && this.tblData[key]) {
          filtered = true;
          arinvlist[key] = this.tblData[key];
        }
      }
      if (filtered === true) {
        arinvlist.page = this.tblData.page;
        arinvlist.limit = this.tblData.limit;
        arinvlist.sortBy = this.tblData.sortBy;
        arinvlist.sortDesc = this.tblData.sortDesc;
        const filter = this.$store.state.filter;
        filter.arinvlist = arinvlist;
        this.$store.commit("filter", filter);
      }
    },
    handleOk: function (evt) {
      evt.preventDefault();
      if (this.invalidModel) {
        console.log("validation : ", this.$v.frmdata);
        console.log("frmdata obj : ", this.frmdata);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        this.showStatusForm = false;
        // this.$forceUpdate();
        this.updateStatus();
      }
    },
    updateStatus: async function () {
      this.isLoading = true;
      try {
        await arinv.updatecollect(this.frmdata);
        for (var key in this.frmdata) {
          this.model[key] = this.frmdata[key];
        }
        const stat = this.dataList.ostandStatus.find((s) => s.value == this.frmdata.ostStatuskey);
        if (stat) {
          this.model.ostStatusname = stat.text;
        }

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        this.showStatusForm = true;
        console.log("error : ", error);
        if (error.sql) {
          toastr.error(error.sql, "ERROR MESSAGE", 10000);
        } else if (error.sqlMessage) {
          toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
        } else if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    showActionHistory: async function (record) {
      try {
        this.model = record;
        this.isLoading = true;
        const data = await arinv.detailcollection(record);
        this.actionHistory = data;
        this.actionHistoryShow = true;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log("error : ", error);
        if (error.sql) {
          toastr.error(error.sql, "ERROR MESSAGE", 10000);
        } else if (error.sqlMessage) {
          toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
        } else if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },

    rowPayment(record) {
      this.model = record;
      this.payment();
    },
    rowCollstatus(record) {
      this.rowClicked(record);
      this.collectionStatus();
    },
    rowPrint(record) {
      this.rowClicked(record);
      this.print();
    },
    rowPrintkwitansi(record) {
      this.rowClicked(record);
      this.printkwitansi();
    },

    // payment: function() {
    //     if (this.model) {
    //     this.saveFilter();
    //       router.push({name :'receivable.arinvpayview', params: { arinvKey: this.model.arinvKey}});
    //       // this.showStatusForm=true;
    //     } else {
    //         toastr.warn('Please select a row that want to be Edit!');
    //     }
    // },
    payment: async function () {
      if (this.model.arinvKey) {
        toastr.info("Loading Payment/Settlement Detail..", "AR Invoice", 10000);
        const row = { totalsettle: 0, outstand: 0 };
        for (var key in this.model) {
          row[key] = this.model[key];
        }
        // row.tanggal = row.tanggal ? moment(row.tanggal).format('YYYY-MM-DD') : '';
        row.invdate = row.invdate ? moment(row.invdate).format("YYYY-MM-DD") : "";
        this.paymdata = row;
        const ds = await arinv.detailsettle(this.model);
        this.paymdata.paymLines = ds[1];
        let totalsettle = 0;
        this.paymdata.paymLines.forEach(function (trx) {
          totalsettle += trx.nilaibayar || 0;
        });
        this.paymdata.totalsettle = totalsettle;
        this.$forceUpdate();
        this.showPaymentForm = true;
        this.refresh();
      } else {
        toastr.warn("Please select a row that want to be view the Payment!");
      }
    },

    print: async function () {
      if (this.model) {
        try {
        this.reportUrl=null; this.showReport = true;
          this.reportUrl = await arinv.print(this.model);
          if (this.$isMobile()) {
            this.showReport = false;
            window.location.href = `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
          }
        } catch (error) {
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      } else {
        toastr.warn("Please select a row that want to be Printed!");
      }
    },
    printkwitansi: async function () {
      if (this.model) {
        try {
        this.reportUrl=null; this.showReport = true;
          this.isprintjv = false;
          this.reportUrl = await arinv.printkwitansi(this.model);
          if (this.$isMobile()) {
            this.showReport = false;
            window.location.href = `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
          }
        } catch (error) {
          console.log(error);
          if (error.sql) {
            toastr.error(error.sql, "ERROR MESSAGE", 10000);
          } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
          } else if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      } else {
        toastr.warn("Please select a row that want to be Printed!");
      }
    },
    printlist: async function () {
      try {
      this.reportUrl=null; this.showReport = true;
        this.reportUrl = await arinv.collectorprintlist(this.tblData);
        if (this.$isMobile()) {
          this.showReport = false;
          window.location.href = `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
        }
      } catch (error) {
        if (error.message) {
          toastr.error(error.message);
        } else {
          toastr.error(JSON.stringify(error));
        }
      }
    },
    printlistbycustomer: async function () {
      try {
      this.reportUrl=null; this.showReport = true;
        this.reportUrl = await arinv.collectorprintlistbycustomer(this.tblData);
        if (this.$isMobile()) {
          this.showReport = false;
          window.location.href = `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
        }
      } catch (error) {
        if (error.message) {
          toastr.error(error.message);
        } else {
          toastr.error(JSON.stringify(error));
        }
      }
    },
    collectionStatus: function () {
      if (this.model) {
        this.frmdata.ostStatuskey = "";
        this.frmdata.colleNote = "";
        this.frmdata.collector_id = "";
        for (var key in this.model) {
          this.frmdata[key] = this.model[key];
        }
        this.showStatusForm = true;
      } else {
        toastr.warn("Please select a row that want to be Edit!");
      }
    },
    deleteConfirm() {
      if (this.model) {
        this.showDelConfirm = true;
      } else {
        toastr.warn("Please select a row that want to be Delete!");
      }
    },
    deleteData: async function () {
      await arinv.remove(this.model);
      this.refresh();
    },
    rowClicked(record, index) {
      if (this.model.arinvKey == record.arinvKey) {
        if (this.showStatusForm == false && this.showActionHistory == true) {
          this.payment();
        }
      } else {
        if (this.model && this.model._rowVariant) {
          delete this.model._rowVariant;
        }
        this.model = record;
        record._rowVariant = "info";
        this.$forceUpdate();
      }
    },
    printjv: async function () {
      if (this.model) {
        this.isLoading = true;
        try {
        this.reportUrl=null; this.showReport = true;
          this.reportUrl = await arinv.printjv(this.model);
          this.isLoading = false;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      } else {
        toastr.warn("Please select a row that want to be Printed!");
      }
    },
    exportxls: async function () {
      this.isLoading = true;
      try {
        await arinv.collectorexport(this.tblData);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message);
        } else {
          toastr.error(JSON.stringify(error));
        }
      }
    },
    close() {
      router.push("/receivable/home");
    },
  },
};
</script>
